export default "__VITE_ASSET__D$36I3Tk__"